import { useQuery } from "@tanstack/react-query";
import { getWLDriversByCountryApi } from "../api/getWLDriversByCountryApi";
import { DEFAULT_COUNTRY_CODE } from "../forecastConstants";
const THIRTY_MINUTES_MS = 30 * 60 * 1000;
export const useGetWLDriversCountry = (forecastApi, countryCode, enabled = true) => {
    const code = countryCode ?? DEFAULT_COUNTRY_CODE;
    const { data, refetch, isLoading, error } = useQuery({
        queryKey: ["forecast-drivers-country", code],
        queryFn: ({ signal }) => getWLDriversByCountryApi(forecastApi, code, signal),
        refetchOnWindowFocus: false,
        refetchInterval: THIRTY_MINUTES_MS,
        staleTime: THIRTY_MINUTES_MS,
        enabled,
    });
    return {
        data: data ?? [],
        isLoading,
        error,
        refetch,
    };
};
//# sourceMappingURL=useGetWLDriversCountry.js.map